import angular from 'angular';
import Analytics from 'angular-google-analytics';
import {BaseFormController} from '../../jangl/BaseFormController';
import {HealthDataModel, LifeDataModel} from "../models";

export class TorchmarkFormController extends BaseFormController {
    constructor(passthroughService, metaService, contactService, dataService, leadidService, extraDataService,
                extraLabelService, analytics, $scope) {
        super(passthroughService, metaService, contactService, dataService, leadidService);
        this.scope = $scope;
        this.analytics = analytics;
        this.extraDataService = extraDataService;
        this.extraLabelService = extraLabelService;

        this.steps = [
            {name: 'Personal', formName: 'formStep0', formType: null },
        ];

        this.stateOptionsUA = dataService.getStateOptions().STATE_OPTIONS_UA;
        this.stateOptionsGlobeLife = dataService.getStateOptions().STATE_OPTIONS_GL;
        this.stateOptionsGlobeLife_Underage = dataService.getStateOptions().STATE_OPTIONS_GL_UNDERAGE;
        this.stateOptionsGLNewYork = dataService.getStateOptions().STATE_OPTIONS_GL_NY;
        this.formDisabled = {
            verticalForm: true,
            userDetailForm:true
        }
        this.trueValue = true;
        this.falseValue = false;
        this.isOnlyHealthVertical = false;
        this.UA = 'UA';
        this.GLOBE_LIFE = 'Globe Life';
        this.GLOBE_LIFE_NY = 'Globe Life New York';
        this.company_carrier;
        this.is_conversion;
        this.is_spouse_household;
        this.is_age_over;
        this.requireSpousePolicyNumber = false;
        this.policyNumberMaxlength = 255;
        this.commentsMaxLength = 5000;
        this.POLICY_NUMBER_MAX_LENGTH_ERROR = 'Policy Number should not be more than 255 characters length.'
        this.SPOUSE_POLICY_MAX_LENGTH_ERROR = 'Spouse Policy Number should not be more than 255 characters length.'
        this.COMMENTS_MAX_LENGTH_ERROR = 'Comments should not be more than 5000 characters length.'
        this.AGE_ERROR_MESSAGE = 'This age does not qualify for this product.';

        this.bestTimeToCallOptions = dataService.getBestTimeToCallOptions();
        this.howDidYouHearOptions = dataService.getHowDidYouHearOptions();
        this.languageOptions = dataService.getLanguageOptions();
        this.ageOptions = dataService.getAgeOptions();

        this.productType = 'health';
        this.productOptions = [];
        this.ageMin = 16;
        this.ageMax = 100;
        this.rootExtraData = [];
    }

    /**
     * Returns true if the Birthday field should be disabled (for Juvenile Life product in life vertical)
     * Also sets the isJuvenileLifeProduct flag on the contact model for validation logic in BaseModel.
     */
    isBirthdayDisabled() {
        const juvenileLifeProduct = this.config &&
            this.config.life_products &&
            this.config.life_products.find(product => product.name === 'Juvenile Life');
        const isJuvenile = this.productType === 'life' && juvenileLifeProduct && this.token === juvenileLifeProduct.token;
        if (this.contactModel) {
            this.contactModel.isJuvenileLifeProduct = !!isJuvenile;
        }
        return isJuvenile;
    }

    $onInit() {
        super.$onInit();

        this.getProductOptions();
        this.doneCopy = 'Thank you for your request. A licensed agent will contact you as soon as possible';

        this.extraDataModel = this.extraDataService.newModel(this.extra_data);
        this.extraLabelModel = this.extraLabelService.newModel();

        this.scope.$watchCollection('$ctrl.dataModel.birth_date',
            (newDate, oldDate) => this.updateAge('dataModel', newDate, oldDate));
        this.scope.$watchCollection('$ctrl.extraDataModel.spouse_birth_date',
            (newDate, oldDate) => this.updateAge('extraDataModel', newDate, oldDate));
        this.scope.$watch('$ctrl.dataModel.phone', () => this.emailPlaceHolder = this.getEmail());

        this.disableBirthdayField = this.isBirthdayDisabled();
    }

    serialize() {
        if (!this.dataModel.address) this.dataModel.address = this.getAddress();
        if (!this.dataModel.email) this.dataModel.email = this.getEmail();

        const juvenileFlag = this.isBirthdayDisabled();
        let patchedData = angular.extend({}, this.dataModel, {
            isJuvenileLifeProduct: juvenileFlag
        });
        let patchedContact = angular.extend({}, this.dataModel, {
            isJuvenileLifeProduct: juvenileFlag
        });
        this.contactModel = this.updateModel(this.contactModel, patchedContact);

        this.dataModel = this.updateModel(this.dataModel, patchedData);
        this.dataModel.isJuvenileLifeProduct = this.isBirthdayDisabled();
        if (this.dataModel.phone2) this.contactModel.phone2 = this.dataModel.phone2;
        this.contactModel.isJuvenileLifeProduct = !!this.isBirthdayDisabled();

        super.serialize();
        if (this.productType === 'life') {
            let personModel = new LifeDataModel(this.submission.data);
            let personSerialized = this.updateModel(personModel, this.submission.data, true);
            // We need to clean all the data used to populate extra fields
            this.submission.data = {};
            this.submission.data.persons = [personSerialized];
        } else {
            let personModel = new HealthDataModel(this.submission.data);
            let personSerialized = this.updateModel(personModel, this.submission.data, true);
            // We need to clean all the data used to populate extra fields
            this.submission.data = {};
            this.submission.data = personSerialized;
        }
        this.submission.extra_data = this.extraDataModel.serialize();
        this.submission.extra_labels = this.extraLabelModel.serialize();

        // Move desired extra data to the root serialized object
        this.rootExtraData.forEach(function (element) {
            if (this.submission.extra_data.hasOwnProperty(element)) {
                this.submission[element] = this.submission.extra_data[element];
                delete this.submission.extra_data[element];
            }
            if (this.submission.extra_labels.hasOwnProperty(element)) {
                delete this.submission.extra_labels[element];
            }
        }, this)
    }

    reset() {
        this.step = 0;
        this.token = null;
        angular.forEach(this.scope.formStep0, function (input) {
            if (input && input.hasOwnProperty('$viewValue')) {
                input.$setUntouched();
            }
        });

        this.contactModel = this.contactService.newModel();
        this.dataModel = this.dataService.newModel();
        this.extraDataModel = this.extraDataService.newModel();
        this.formDisabled = {
            verticalForm: true,
            userDetailForm: true
        }
        this.company_carrier = '';
        this.is_conversion = '';
        this.is_spouse_household = '';
        this.is_age_over = '';
        this.isOnlyHealthVertical = false;
        this.maxAge = null;
        this.minAge = null;
    }

    submit() {
        this.serialize();
        // reset errors on submit.
        this.errors = [];

        // post to backend.
        this.dataService.capture(this.token, this.productType, this.submission)
            .then(response => {
                try {
                    this.analytics.trackEvent('submit_success');
                } catch (error) {
                    console.log('Error after submit in analytics.trackEvent = ', error)
                }

                this.handleThen(response);
            })
            .catch(errors => this.handleCatch(errors));
    }

    getAddress() {
        return 'No value provided';
    }

    getEmail() {
        return (this.dataModel.phone) ? `${this.dataModel.phone || 'phone'}@has-no.email` : '';
    }

    buildDate(date, setAge) {
        if (!date.month && !date.day && !date.year && !setAge && date < 0) return {month: null, day: null, year: null};

        return date;
    }

    dateToAge(date) {
        if (date.hasOwnProperty('month') && date.hasOwnProperty('year') && date.hasOwnProperty('day')) {
            let dateNullValues = Object.values(date).filter((value) => value === null).length;
            if (dateNullValues > 0) {
                return null;
            }

            let today = new Date();
            let birthDate = new Date(date.year, date.month, date.day);
            let age = today.getFullYear() - birthDate.getFullYear();
            let m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }
        return null;
    }

    /**
     * Validate birth date against products like Med Supp 64+ and Med Supp Underage
     */
    birthDateValidationAgainstProduct() {
        this.maxAge = null;
        this.minAge = null;
        if (this.dataModel.age && this.token && this.productOptions) {
            const product_Med_Supp = this.productOptions.filter(product => product.label === 'Med Supp 64+');
            const product_MS_Underage = this.productOptions.filter(product => product.label === 'Med Supp Underage');

            if (
              product_Med_Supp &&
              product_Med_Supp.length > 0 &&
              product_Med_Supp[0].key === this.token &&
              this.dataModel.age < 64)
            {
              this.maxAge = null;
              this.minAge = 64;
            } else if (
              product_MS_Underage &&
              product_MS_Underage.length > 0 &&
              product_MS_Underage[0].key === this.token &&
              this.dataModel.age > 64
            ) {
              this.maxAge = 64;
              this.minAge = null;
            }
        }
    }

    updateAge(model, newDate, oldDate) {
        if (newDate && oldDate) {
            let newDateNulls = Object.values(newDate).filter((value) => value === null).length;
            let oldDateNulls = Object.values(oldDate).filter((value) => value === null).length;
            if (newDateNulls > oldDateNulls) {
                this.cleanModel(model);
                return;
            }
        }
        if (model === 'extraDataModel') {
            if (this.extraDataModel.hasOwnProperty('spouse_birth_date')) {
                this.extraDataModel.spouse_birth_date = this.buildDate(this.extraDataModel.spouse_birth_date, null);
                this.extraDataModel.spouse_age = this.dateToAge(this.extraDataModel.spouse_birth_date);
            }
        }
        if (model === 'dataModel') {
            if (this.dataModel.hasOwnProperty('birth_date')) {
                this.dataModel.birth_date = this.buildDate(this.dataModel.birth_date, null);
                this.dataModel.age = this.dateToAge(this.dataModel.birth_date);
            }
            this.birthDateValidationAgainstProduct();
        }
    }

    cleanModel(model) {
        if (model === 'dataModel') {
            this.dataModel.birth_date.year = null;
            this.dataModel.birth_date.month = null;
            this.dataModel.birth_date.day = null;
            this.dataModel.age = null;
        }
        if (model === 'extraDataModel') {
            this.extraDataModel.spouse_birth_date.year = null;
            this.extraDataModel.spouse_birth_date.month = null;
            this.extraDataModel.spouse_birth_date.day = null;
            this.extraDataModel.spouse_age = null;
        }
    }

    updateModel(model, object, serialized=false) {
        let newObject = {};
        model._required.map(field => (object[field]) ? newObject[field] = object[field] : null);
        return (serialized) ? newObject : Object.assign(model, newObject);
    }

    /**
     * Show 'Med Supp 64+', 'Med Supp Underage', 'Conversion' Products when Globe Life is selected
     */
    removeConversionInProductOptions(productOptionsList) {
        return productOptionsList.filter(product => product.label !== 'Conversion');
    }

    /**
     * Reset Product and also remove age validation as
     * product is not related to age.
     */
    resetProductAndRemoveAgeValidation() {
        this.token = null;
        this.setProduct(this.token);
        this.maxAge = null;
        this.minAge = null;
    }

    /**
     * When Are you over the age of 64 is Yes hide Med Supp Underage and if radio button is false
     * hide 'Med Supp 64+'
     */
    setAgeOptionsProductList(productOptionsList) {
        //If Age is over the 64 years then hide Med Supp Underage if below the 64 years hide Med Supp 64+
        if (this.is_age_over) {
            productOptionsList = productOptionsList.filter(product => !product.label.includes('Med Supp Underage'));
        } else if (this.is_age_over === false) {
            productOptionsList = productOptionsList.filter(product => !product.label.includes('Med Supp 64+'));
        }
        return productOptionsList;
    }

    /**
     * Set Product as conversion and enable user detail form also remove validation
     * for birth date/age as product is not related to age.
     */
    getProductOptionsConversion(productOptionsList) {
        productOptionsList = productOptionsList.filter(productOption => productOption.label === 'Conversion');
        const product = productOptionsList.filter(productOption => productOption.label === 'Conversion');
        if (product && product.length > 0) {
            this.token = product[0].key;
            this.setProduct(this.token);
            /*Enable rest of the form on the selection of a product from the dropdown
            and if vertical form is enabled*/
            if (!this.formDisabled.verticalForm) {
                this.formDisabled.userDetailForm = false;
            }
            //As product is set as conversion remove max age and min age validation of birth_date
            this.maxAge = null;
            this.minAge = null;
        }
        return productOptionsList;
    }

    /**
     * General filter function to remove products based on labels
     */
    removeProductsByLabels(productOptionsList, labelsToRemove) {
        return productOptionsList.filter(product => !labelsToRemove.some(label => product.label.includes(label)));
    }

    /**
     * Specific filter functions for each company
     */
    getProductOptionsUA(productOptionsList) {
        const labelsToRemove = ['Postcard & Email', 'GLA Med', 'GlobeLife', 'Other'];
        return this.removeProductsByLabels(productOptionsList, labelsToRemove);
    }

    getProductOptionsGlobeLife(productOptionsList) {
        const labelsToKeep = ['GLA Med Supp 64+', 'GLA Med Supp Underage', 'Conversion'];
        return productOptionsList.filter(product => labelsToKeep.includes(product.label));
    }

    getProductOptionsGlobeLifeNY(productOptionsList) {
        const labelsToRemove = ['Cancer/Critical/Accident/MGAP', 'GlobeLifeInsurance.com Leads', 'Postcard & Email', 'GLA Med', 'GlobeLife', 'Other'];
        return this.removeProductsByLabels(productOptionsList, labelsToRemove);
    }

    /**
     * Main function to get filtered product options
     */
    getProductOptions() {
        const dictName = (this.productType === 'life') ? 'life_products' : 'health_products';
        let productOptionsList = [];

        if (this.config.hasOwnProperty(dictName)) {
            productOptionsList = this.config[dictName].map(product => ({ label: product.name, key: product.token }));
        }

        // Filter based on company carrier
        if (this.company_carrier === this.UA) {
            productOptionsList = this.getProductOptionsUA(productOptionsList);
        } else if (this.company_carrier === this.GLOBE_LIFE) {
            productOptionsList = this.getProductOptionsGlobeLife(productOptionsList);
        } else if (this.company_carrier === this.GLOBE_LIFE_NY) {
            productOptionsList = this.getProductOptionsGlobeLifeNY(productOptionsList);
        }

        // If Conversion? OR SPOUSE/HOUSEHOLD POLICYHOLDER? is Yes show only Conversion in product option list
        if (this.is_conversion || this.is_spouse_household) {
            productOptionsList = this.getProductOptionsConversion(productOptionsList);
        } else {
            // if Conversion? AND SPOUSE/HOUSEHOLD POLICYHOLDER? both is No remove Conversion from Product option list
            productOptionsList = this.removeConversionInProductOptions(productOptionsList);
            this.resetProductAndRemoveAgeValidation();
        }

        // If Age is over the 64 years then hide Med Supp Underage if below the 64 years hide Med Supp 64+
        productOptionsList = this.setAgeOptionsProductList(productOptionsList);
        this.productOptions = productOptionsList;
    }

    setProductType(productType) {
        this.productType = productType;
        this.getProductOptions();
    }

    /**
     * If product is Other then comments will be required
     * @returns
     */
    isCommentsRequired() {
        const productOther = this.productOptions.find(product => product.label === 'Other');
        return productOther && productOther.key === this.token ? true:false;
    }

    setProduct(token) {
        if (token) {
            // Checking company carrier and setting the state options if company carrier is Globe Life and product is GLA Med Supp Underage
            if (this.productOptions.find(product => product.label === 'GLA Med Supp Underage')
                && this.company_carrier === this.GLOBE_LIFE) {
                this.stateOptions = angular.copy(this.stateOptionsGlobeLife_Underage);
            } else {
                // Resetting state options based on company carrier if product was changed
                if (this.company_carrier === this.UA) {
                    this.stateOptions = angular.copy(this.stateOptionsUA);
                } else if (this.company_carrier === this.GLOBE_LIFE) {
                    this.stateOptions = angular.copy(this.stateOptionsGlobeLife);
                } else {
                    this.stateOptions = angular.copy(this.stateOptionsGLNewYork);
                }
            }
            this.disableBirthdayField = this.isBirthdayDisabled();
            //Enable rest of the form on the selection of a product from the dropdown
            this.formDisabled.userDetailForm = false;
            this.birthDateValidationAgainstProduct();
        }
    }

    /**
     * Return true or false value to show only Health Vertical Button
     * Show Health Vertical button if Globe Life company is selected or 
     * if UA or Globe-Life-New-York company is selected and question 
     * conversion or spouse household is Yes
     */
    showOnlyHealthVertical() {
        return (this.company_carrier == this.GLOBE_LIFE || (([this.UA, this.GLOBE_LIFE_NY].indexOf(this.company_carrier) >= 0) &&
            (this.is_conversion || this.is_spouse_household)
        )
        )
    }

    /**
     * Checks if need to show only health vertical and reset product list 
     * and reset state value and if birth date exists remove that birth date
     */
    resetOnChangeCompanyOrFilterQuestion() {
        //to show health or life vertical buttons
        this.isOnlyHealthVertical = this.showOnlyHealthVertical();
        if (this.isOnlyHealthVertical) {
            this.setProductType('health');
        } else {
            this.getProductOptions();
        }

        //Reset state if value exists
        if(this.dataModel.state) {
            this.dataModel.state = '';
        }
        //Reset birth_date if value exists
        if (this.dataModel.birth_date) {
            this.cleanModel('dataModel');
        }

        //Disable user detail form if product is not selected and userdetail form is enabled
        if (!this.formDisabled.userDetailForm && (!this.token || (this.is_conversion === false && this.is_spouse_household === false && 
            [true, false].indexOf(this.is_age_over) === -1))) {
            this.formDisabled.userDetailForm = true;
        }
    }

    /**
     * Reset value as of policy number and spouse policy number as undefined
     */
    resetPolicyNumbers() {
        //reset value of policy number to undefined when conversion is false and policy_number exists
        if (this.is_conversion === false && this.extraDataModel.policy_number) {
            this.extraDataModel.policy_number = undefined;
        }
        //reset value of spouse policy number when spouse household policyholder is false and spouse_policy_number exists
        if (this.is_spouse_household === false && this.extraDataModel.spouse_policy_number) {
            this.extraDataModel.spouse_policy_number = undefined;
        }
    }
    
    /**
     * On Selection of company carrier UA/GL/GL New York
     * set the value of state dropdown and on selection of 
     * Globe Life show only Health insurance vertical
     * @param {*} value 
     */
    onChangeCompanyCarrier(value) {
        //On Selection of company 
        if (value === this.UA) {
            this.stateOptions = angular.copy(this.stateOptionsUA);
        } else if (value === this.GLOBE_LIFE) {
            this.stateOptions = angular.copy(this.stateOptionsGlobeLife);
        } else {
            this.stateOptions = angular.copy(this.stateOptionsGLNewYork);
        }
        this.resetOnChangeCompanyOrFilterQuestion();
    }

    /**
     * On change of filter questions
     */
    onChangeQuestionForm() {
        const truefalseArray = [true, false];
        //Enable the vertical form if conversion, spouse-household and are you age over question are selected
        if (this.is_conversion === false && this.is_spouse_household === false) {
            if (truefalseArray.indexOf(this.is_age_over) >= 0) {
                this.formDisabled.verticalForm = false;
            } else {
                this.formDisabled.verticalForm = true;
                this.formDisabled.userDetailForm = true;
            }
        } else if (this.is_conversion === true || this.is_spouse_household === true) {
            this.formDisabled.verticalForm = false;
            if (truefalseArray.indexOf(this.is_age_over) >= 0) {
                this.is_age_over = '';
            }
        }
        this.resetOnChangeCompanyOrFilterQuestion();
        this.resetPolicyNumbers();
    }
    
}

TorchmarkFormController.$inject = [
    'janglPassthroughService', 'janglMetaService' , 'janglContactService',
    'janglTorchmarkDataService', 'journayaLeadIdService', 'janglExtraDataService',
    'janglExtraLabelService', 'Analytics', '$scope'
];
export default TorchmarkFormController;


// WEBPACK FOOTER //
// ./app/torchmark/torchmark-form/controller.js